import { BaseDataModel } from "./base";

export class Region extends BaseDataModel {
	name!: string;
	branchIds?: string[];
	companyIds?: string[];
}
